<template>
  <!-- <div>
    <v-sheet elevation="0" color="#57bc90" style="min-height: 70vh;">
      <p class="text-center body-1 font-weight-bold pt-3">
        Check back after week 1 of NFL
      </p>
    </v-sheet>
  </div> -->
  <div>
    <v-sheet elevation="0" color="#57bc90" style="min-height: 100vh">
      <v-col cols="12" md="12" sm="12">
        <p class="text-h5 white--text font-weight-bold mt-3">Game Logs</p>
        <v-row align="center" justify="center" class="mb-n5">
          <v-col cols="2">
            <p class="body-2 white--text font-weight-bold">FUMBLES</p>
          </v-col>
          <v-col cols="2">
            <p class="body-2 white--text font-weight-bold">RECEIVING</p>
          </v-col>
          <v-col cols="2" class="ml-6">
            <p class="body-2 white--text font-weight-bold">RUSHING</p>
          </v-col>
        </v-row>

        <!-- //* game stats... -->
        <div>
          <v-data-table
            :headers="header"
            :items="stats"
            class="elevation-1"
            hide-default-footer
            sort-by="Day"
            sort-desc
            mobile-breakpoint="0"
          >
            <!-- header -->
            <template
              v-for="h in header"
              v-slot:[`header.${h.value}`]="{ header }"
            >
              <v-tooltip bottom :key="h.text">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ h.text }}</span>
                </template>
                <span>{{ h.hint }}</span>
              </v-tooltip>
            </template>
            <!-- header -->

            <template v-slot:item.Day="{ item }">
              <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
            </template>

            <template v-slot:item.FantasyPointsDraftKings="{ item }">
              <p v-if="operator == 'FanDuel'" class="body-2">
                {{ item.FantasyPointsFanDuel }}
              </p>

              <p v-if="operator == 'DraftKings'" class="body-2">
                {{ item.FantasyPointsDraftKings }}
              </p>
            </template>
          </v-data-table>
        </div>

        <!-- //* season stats... -->
        <!-- <p class="text-h5 white--text font-weight-bold mt-3">
          Season Logs
        </p>
        <div class="mt-n3">
          <v-data-table
            :headers="seasonHeader"
            :items="stats.seasonstats"
            class="elevation-1"
            hide-default-footer
            sort-by="Day"
            sort-desc
            mobile-breakpoint="0"
          >

            <template
              v-for="h in seasonHeader"
              v-slot:[`header.${h.value}`]="{ seasonHeader }"
            >
              <v-tooltip bottom :key="h.text">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ h.text }}</span>
                </template>
                <span>{{ h.hint }}</span>
              </v-tooltip>
            </template>


            <template v-slot:item.Day="{ item }">
              <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
            </template>

            <template v-slot:item.FantasyPointsDraftKings="{ item }">
              <p v-if="operator == 'FanDuel'" class="body-2">
                {{ item.FantasyPointsFanDuel }}
              </p>

              <p v-if="operator == 'DraftKings'" class="body-2">
                {{ item.FantasyPointsDraftKings }}
              </p>
            </template>
          </v-data-table>
        </div> -->
      </v-col>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "NflfullStats",

  props: {
    stats: {
      type: [Array, Object],
      default: () => [],
    },
  },

  data() {
    return {
      operator: localStorage.getItem("gameOperator"),
      header: [
        { text: "Season", value: "Season" },
        { text: "Team", value: "Team" },
        { text: "FUM", value: "Fumbles", hint: "fumbles" },
        { text: "FF", value: "FumblesForced", hint: "fumbles forced" },
        { text: "LNG", value: "ReceivingLong", hint: "Receiving long" },
        { text: "TGT", value: "ReceivingTargets", hint: "Receiving target" },
        {
          text: "TD",
          value: "ReceivingTouchdowns",
          hint: "Receiving touchdowns",
        },
        { text: "YDS", value: "ReceivingYards", hint: "Receiving yards" },
        { text: "REC", value: "Receptions", hint: "Receptions" },
        { text: "ATT", value: "RushingAttempts", hint: "Rushing Attempts" },
        { text: "LNG", value: "RushingLong", hint: "Rushing long" },
        {
          text: "TD",
          value: "RushingTouchdowns",
          hint: "Rushing touchdowns",
        },
        { text: "YDS", value: "RushingYards", hint: "Rushing yards" },
        {
          text: "FP",
          value: "FantasyPointsDraftKings",
          hint: "Fantasy Points",
        },
      ],

      seasonHeader: [
        { text: "Season", value: "Season" },
        { text: "Opponent", value: "Opponent" },
        { text: "FUM", value: "Fumbles", hint: "fumbles" },
        { text: "FF", value: "FumblesForced", hint: "fumbles forced" },
        { text: "LNG", value: "ReceivingLong", hint: "Receiving long" },
        { text: "TGT", value: "ReceivingTargets", hint: "Receiving target" },
        {
          text: "TD",
          value: "ReceivingTouchdowns",
          hint: "Receiving touchdowns",
        },
        { text: "YDS", value: "ReceivingYards", hint: "Receiving yards" },
        { text: "REC", value: "Receptions", hint: "Receptions" },
        { text: "ATT", value: "RushingAttempts", hint: "Rushing Attempts" },
        { text: "LNG", value: "RushingLong", hint: "Rushing long" },
        {
          text: "TD",
          value: "RushingTouchdowns",
          hint: "Rushing touchdowns",
        },
        { text: "YDS", value: "RushingYards", hint: "Rushing yards" },
        {
          text: "FP",
          value: "FantasyPointsDraftKings",
          hint: "Fantasy Points",
        },
      ],
    };
  },
};
</script>

<style scoped>
.basil {
  background-color: #fffbe6 !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
